require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-looking-ahead-to-the-2022-global-disability-summit.json") })
        }
      }, "path---en-us-update-looking-ahead-to-the-2022-global-disability-summit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-looking-ahead-to-the-2022-global-disability-summit!./.cache/json/en-us-update-looking-ahead-to-the-2022-global-disability-summit.json
// module id = 771
// module chunks = 231608221292675